export default __webpack_public_path__ + "91117ee6228af54cc6114330b11107a9.svg";